module.exports = __webpack_public_path__ + "img/screenShu.7d61988d.png";